type ConsoleLogPackagesAnalyticsProps = {
  heading: string;
  message: string;
};

export const consoleLogPackagesAnalytics = ({
  heading,
  message,
}: ConsoleLogPackagesAnalyticsProps) =>
  console.log(
    `[@packages/analytics] ${heading}:\n\t${JSON.stringify(message)}`,
  );
